import { SimpleGrid } from "@chakra-ui/react";

import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export default function DoubleColumn({ children }: Props) {
  return (
    <SimpleGrid minChildWidth="300px" columnGap="20px" rowGap="20px">
      {children}
    </SimpleGrid>
  );
}
